import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/jqr2.png';
import _imports_1 from '../../../assets/camera.png';
import _imports_2 from '../../../assets/new/49.png';
import _imports_3 from '../../../assets/new/50.png';
import _imports_4 from '../../../assets/new/10.png';
const _withScopeId = n => (_pushScopeId("data-v-141cd113"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bg-white",
  style: {
    "height": "100%"
  }
};
const _hoisted_2 = {
  style: {
    "padding": "50px 20px 0"
  }
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div style=\"background:#3a3f53;box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.5);border-radius:19px;position:relative;color:#ffffff;padding:25px 0;font-size:17px;\" data-v-141cd113><div style=\"position:absolute;top:-23px;height:46px;width:100%;\" data-v-141cd113><div class=\"css3\" data-v-141cd113>帮你解决阅读中的几大难题</div></div><div style=\"padding:15px 20px 0;\" data-v-141cd113><div style=\"display:flex;align-items:end;\" data-v-141cd113><div style=\"padding-right:10px;\" data-v-141cd113><p data-v-141cd113>复杂长难句别发愁，帮你找出主句和从句，拆分句子的主谓宾。</p><br data-v-141cd113><p data-v-141cd113>句子中多词性单词理解不用怕，帮你找到唯一词性解释。</p></div><img src=\"" + _imports_0 + "\" style=\"flex:0 0 80px;transform:rotateY(180deg);\" data-v-141cd113></div></div></div>", 1);
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "18px",
    "color": "#181818",
    "flex": "0 0 70%"
  }
}, "请在下方文本框内输入完整的一句话，或者点击右侧相机拍照。", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#1483ff"
  }
}, "拍照", -1));
const _hoisted_6 = {
  style: {
    "background": "#e7f6ff",
    "border": "1px solid #0086f0",
    "border-radius": "16px",
    "padding": "20px"
  }
};
const _hoisted_7 = {
  class: "box"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "6rem"
  }
}, null, -1));
const _hoisted_9 = {
  class: "footer"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { getLocalPid } from "../../../libs/util";
import { ElMessage } from "element-plus";
import { getSitename, grammarSplit, ocr } from "../../../api/index";
import Header from "../../../components/header.vue";
import analyse from "../../../components/analyse2.vue";
const none = "You can fill in an English sentence here so that you can get the part of speech of the word as well as the explanation of the grammatical knowledge of the sentence";
export default {
  __name: 'photo',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const store = useStore();
    const router = useRouter();
    const pid = getLocalPid();
    const queryTxt = ref("");
    const theRequest = [];
    const txt = ref("");
    let ct = "";
    const isAnalyse = ref(false);
    const safeMes = computed(() => store.state.safeMes);
    onMounted(() => {
      if (location.search.indexOf("?") != -1) {
        let query = location.search.substring(1);
        let strs = query.split("&");
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      if (pid) {
        getSitename({
          pid
        }).then(res => {
          document.title = res.data.data.siteName;
          localStorage.setItem('title', res.data.data.siteName);
        }).catch(() => {
          ElMessage.error("获取站点名称失败");
        });
      } else {
        console.log("URL中没有找到pid");
      }
    });
    const navTo = () => {
      queryTxt.value = "";
      toSegment();
    };
    //  断句
    const toSegment = () => {
      let obj = {
        ...safeMes.value,
        articleId: 0,
        readLogId: 0,
        content: txt.value ? txt.value : none
      };
      grammarSplit(encodeURIComponent(JSON.stringify(obj))).then(({
        data
      }) => {
        if (data.code) {
          return store.commit("judgeCode", {
            code: data.code,
            msg: data.msg
          });
        }
        let list = data.data.lineResults.map(v => {
          return v.validLine;
        });
        queryTxt.value = list;
      }).catch(err => {
        console.log(err);
        ElMessage.error("请求失败");
      });
    };
    const imgClick = () => {
      document.getElementById("uploadFile").click();
    }; //点击选中图片
    const readLocalFile = () => {
      var localFile = document.getElementById("uploadFile").files[0];
      var reader = new FileReader();
      var content;
      reader.onload = function (event) {
        content = event.target.result;
        ct = content;
        isAnalyse.value = true;
        let obj = {
          ...safeMes.value,
          imgBase64: ct
        };
        ocr(obj).then(({
          data
        }) => {
          console.log(data);
          if (data.code) return store.commit("judgeCode", {
            code: data.code,
            msg: data.msg
          });
          txt.value = data.data;
          isAnalyse.value = false;
        }).catch(err => {
          console.log(err);
          ElMessage.error(JSON.stringify(err));
          isAnalyse.value = false;
        });
      };
      reader.onerror = function () {
        alert("error");
      };
      content = reader.readAsDataURL(localFile, "UTF-8");
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(Header, {
        title: 'AI超级工具'
      }), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
        style: {
          "margin": "20px 0",
          "display": "flex",
          "align-items": "center",
          "justify-content": "space-between"
        }
      }, [_hoisted_4, _createElementVNode("div", {
        style: {
          "display": "flex",
          "flex-flow": "column",
          "align-items": "center"
        }
      }, [_createElementVNode("div", {
        class: "css4"
      }, [_createElementVNode("img", {
        src: _imports_1,
        style: {
          "width": "30px"
        },
        onClick: imgClick
      })]), _hoisted_5])]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => txt.value = $event),
        placeholder: none,
        style: {
          "border": "0 none",
          "outline": "none",
          "width": "100%",
          "color": "#032b72",
          "font-size": "17px",
          "min-height": "140px",
          "background": "none"
        }
      }, null, 512), [[_vModelText, txt.value]]), _createElementVNode("button", {
        type: "button",
        class: "css5",
        onClick: _cache[1] || (_cache[1] = $event => navTo())
      }, _toDisplayString(isAnalyse.value ? "分析中..." : "点击分析"), 1)])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("input", {
        style: {
          "display": "none"
        },
        type: "file",
        name: "cover",
        class: "file",
        id: "uploadFile",
        accept: "image/*",
        capture: "camera",
        multiple: "",
        onChange: _cache[2] || (_cache[2] = $event => readLocalFile())
      }, null, 32)]), queryTxt.value ? (_openBlock(), _createBlock(analyse, {
        key: 0,
        queryTxt: queryTxt.value
      }, null, 8, ["queryTxt"])) : _createCommentVNode("", true), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'index',
          query: {
            pid: _unref(pid)
          }
        }))
      }, [_hoisted_10, _createTextVNode(" 原版阅读 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        style: {
          "color": "#35b9ff"
        },
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
          name: 'photo',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_11, _createTextVNode(" AI工具 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[5] || (_cache[5] = $event => _unref(router).push({
          name: 'my',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_12, _createTextVNode(" 个人中心 ")])])])], 2);
    };
  }
};